export default {
    manufacturer_delete_title: "Eliminar fabricante",
    manufacturer_delete_success_message: "Se ha eliminado el fabricante",
    manufacturer_delete_message: "¿Estás seguro de que quieres eliminar al fabricante?",
    manufacturer_delete_general_error: "No ha sido posible eliminar el fabricante debido a un error",
    manufacturer_delete_package_in_use_unit: "El fabricante está vinculado a algunas unidades, por lo que no es posible eliminarlo",
    manufacturer_delete_package_in_use_device_model: "El fabricante está vinculado a algunos modelos de dispositivos, por lo que no es posible eliminarlo",
    manufacturer_delete_package_in_use_unit_type: "El fabricante está vinculado a algunos tipos de unidades, por lo que no es posible eliminarlo",
}